/**
 * Billing Service — paths match Laravel /billing routes.
 * Client used /upgrade and /downgrade — Laravel has /subscribe and /cancel
 * (both aliases added on server side too).
 */
import api from './api';

const billingService = {
  getPlans: () => api.get('/billing/plans').then(r => r.data),
  getMyPlan: () => api.get('/billing/my-plan').then(r => r.data),
  // /billing/upgrade → Laravel /billing/upgrade (aliased to /subscribe)
  upgrade: (plan, paymentMethod, billingInterval) =>
    api.post('/billing/upgrade', { plan, payment_method: paymentMethod, billing_interval: billingInterval }).then(r => r.data),
  // Downgrading was retired on 2026-09-25 — cancel instead, which keeps the
  // plan to the end of the period already paid for. The endpoint still exists
  // and answers 409 DOWNGRADE_NOT_SOLD for older builds; nothing calls it here.
  startTrial: () => api.post('/billing/start-trial').then(r => r.data),
  checkFeature: (feature) => api.get(`/billing/feature-check/${feature}`).then(r => r.data),
  getInvoices: () => api.get('/billing/invoices').then(r => r.data),
  // Vendor subscriptions
  getVendorPlans: () => api.get('/vendor-subscriptions/plans').then(r => r.data),
  getVendorSubscription: () => api.get('/vendor-subscriptions/my').then(r => r.data),
};

export default billingService;
